export const ALERT_COLUMN_LABEL = 'Alert'
